import { areIdsEqual } from '../../utils/strings';
import { getDocumentId } from '../../utils/documents';

export const defaultState = {
  fetching: false,
  personalDocuments: [],
  fetchingError: null,
  searchText: null,
  multiplePersonalDocumentsSelected: false,
};

export const ADD_PERSONAL_DOCUMENT = 'ADD_PERSONAL_DOCUMENT';
export const SET_PERSONAL_DOCUMENTS = 'SET_PERSONAL_DOCUMENTS';
export const CLEAR_PERSONAL_DOCUMENTS = 'CLEAR_PERSONAL_DOCUMENTS';
export const UPDATE_PERSONAL_DOCUMENT = 'UPDATE_PERSONAL_DOCUMENT';
export const DELETE_PERSONAL_DOCUMENT = 'DELETE_PERSONAL_DOCUMENT';
export const SET_FETCHING_PERSONAL_DOCUMENTS =
  'SET_FETCHING_PERSONAL_DOCUMENTS';
export const SET_FETCHING_PERSONAL_DOCUMENTS_ERROR =
  'SET_FETCHING_PERSONAL_DOCUMENTS_ERROR';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_MULTIPLE_PERSONAL_DOCUMENTS_SELECTED =
  'SET_MULTIPLE_PERSONAL_DOCUMENTS_SELECTED';

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_PERSONAL_DOCUMENTS:
      return {
        ...state,
        personalDocuments: action.payload,
      };
    case ADD_PERSONAL_DOCUMENT:
      return {
        ...state,
        personalDocuments: [...(state.personalDocuments || []), action.payload],
      };
    case CLEAR_PERSONAL_DOCUMENTS:
      return defaultState;
    case DELETE_PERSONAL_DOCUMENT:
      return {
        ...state,
        personalDocuments: state.personalDocuments.filter(
          (document) =>
            !areIdsEqual(getDocumentId(document), getDocumentId(action.payload))
        ),
      };
    case UPDATE_PERSONAL_DOCUMENT:
      const updatedDocument = action.payload;

      return {
        ...state,
        personalDocuments: state.personalDocuments.map((document) =>
          areIdsEqual(getDocumentId(document), getDocumentId(updatedDocument))
            ? updatedDocument
            : document
        ),
      };
    case SET_FETCHING_PERSONAL_DOCUMENTS:
      return {
        ...state,
        fetching: action.payload,
      };
    case SET_FETCHING_PERSONAL_DOCUMENTS_ERROR:
      return {
        ...state,
        fetchingError: action.payload,
      };
    default:
      return state;
  }
};

export const sGetPersonalDocumentsModule = (state) => state.personalDocuments;
export const sGetPersonalDocuments = (state) =>
  sGetPersonalDocumentsModule(state).personalDocuments;

export const sGetFetchingPersonalDocuments = (state) =>
  sGetPersonalDocumentsModule(state).fetching;

export const sGetFetchingPersonalDocumentsError = (state) =>
  sGetPersonalDocumentsModule(state).fetchingError;

export const sGetPersonalDocumentSearchText = (state) =>
  sGetPersonalDocumentsModule(state).searchText;

export const sGetMultipePersonalDocumentsSelected = (state) =>
  sGetPersonalDocumentsModule(state).multiplePersonalDocumentsSelected;
